// OneDrive:IgnoreCodeCoverage
import * as React from 'react';
import {
    ShowMalwareDetectedAction as BaseShowMalwareDetectedAction,
    ItemShowMalwareDetectedAction as BaseItemShowMalwareDetectedAction,
    IItemShowMalwareDetectedActionProps as IBaseItemShowMalwareDetectedActionProps,
    IShowMalwareDetectedActionProps as IBaseShowMalwareDetectedActionProps
} from '../../base/actions/showMalwareDetected/ShowMalwareDetectedAction';
import { IDecoratedProps } from '../../../utilities/components/Decorators';
import { connectToItemCache } from '../../decorators/connectToItemCache';
import { asAsync } from '../../../utilities/components/Async';

const MalwareDetectedDialog = asAsync(async () => (
    await import('../../DeferredComponents')
).MalwareDetectedDialog);

function injectMalwareDetectedWizard(): Pick<IBaseItemShowMalwareDetectedActionProps, 'malwareDetectedWizard'> {
    return {
        malwareDetectedWizard: MalwareDetectedDialog
    };
}

export type IItemShowMalwareDetectedActionProps =
    IDecoratedProps<IBaseItemShowMalwareDetectedActionProps, Pick<IBaseItemShowMalwareDetectedActionProps, 'malwareDetectedWizard'>, {}>;

export const ItemShowMalwareDetectedAction: React.ComponentType<IItemShowMalwareDetectedActionProps> =
    connectToItemCache(injectMalwareDetectedWizard)(BaseItemShowMalwareDetectedAction);

export type IShowMalwareDetectedActionProps =
    IDecoratedProps<IBaseShowMalwareDetectedActionProps, Pick<IBaseShowMalwareDetectedActionProps, 'malwareDetectedWizard'>, {}>;

export const ShowMalwareDetectedAction: React.ComponentType<IShowMalwareDetectedActionProps> =
    connectToItemCache(injectMalwareDetectedWizard)(BaseShowMalwareDetectedAction);
